export default "__VITE_ASSET__B2mY$9Ti__"